import { request as apiRequest, BaseResponse } from '../../api';

// 指派状态枚举
export enum AssignStatusEnum {
  ACTIVE = 'active',
  CANCELLED = 'cancelled',
  EXPIRED = 'expired'
}

// 基于时间的状态枚举
export enum TimeBasedStatusEnum {
  NOT_STARTED = 'not_started',  // 未开始
  IN_PROGRESS = 'in_progress',  // 进行中
  EXPIRED = 'expired'           // 已过期
}

// 场景指派信息接口
export interface ScenarioAssignInfo {
  id: string;
  scenario_id: string;
  scenario_name: string;
  scenario_cover?: string;
  assign_type: string;
  target_id: string;
  target_name: string;
  status: string;
  assign_description?: string;
  effective_start_time?: string;
  effective_end_time?: string;
  assigned_by: string;
  assigned_by_name: string;
  created_at: string;
  updated_at: string;
}

// 场景指派列表响应
export interface ScenarioAssignListResponse {
  list: ScenarioAssignInfo[];
  total: number;
  current: number;
  pageSize: number;
}

// 查询参数
export interface ScenarioAssignQuery {
  status?: AssignStatusEnum;
  time_status?: TimeBasedStatusEnum;
  page?: number;
  pageSize?: number;
}

/**
 * 获取当前用户的场景指派列表
 */
export function getMyAssigns(params?: ScenarioAssignQuery): Promise<BaseResponse<ScenarioAssignListResponse>> {
  return apiRequest<ScenarioAssignListResponse>('/scenarios-assign/my-assigns', {
    method: 'GET',
    params,
  });
}

/**
 * 获取场景指派详情
 */
export function getAssignDetail(assignId: string): Promise<BaseResponse<ScenarioAssignInfo>> {
  return apiRequest<ScenarioAssignInfo>(`/scenarios-assign/${assignId}`, {
    method: 'GET',
  });
}

// 为了保持向后兼容，保留原有的接口名称作为别名
export const getTrainingScenes = getMyAssigns;
export type TrainingSceneInfo = ScenarioAssignInfo;
export type TrainingSceneListResponse = ScenarioAssignListResponse;
export type TrainingSceneQuery = ScenarioAssignQuery;
export const TrainingStatus = TimeBasedStatusEnum;